import { FC, memo } from 'react'
import { NodeProps, Position } from '@xyflow/react'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import BaseNode from './BaseNode'
import { TransformNodeData } from '../types'

const TransformNode: FC<NodeProps> = ({ id, data, selected }) => {
  const nodeData = data as TransformNodeData
  const count = nodeData.mappings.length
  const subtitle = count > 0
    ? `${count} field mapping${count !== 1 ? 's' : ''}`
    : 'Set field mappings...'

  return (
    <BaseNode
      nodeType="transform"
      icon={<SwapHorizIcon fontSize="small" />}
      label={nodeData.label}
      nodeId={id}
      subtitle={subtitle}
      selected={selected}
      handles={[
        { type: 'target', position: Position.Top },
        { type: 'source', position: Position.Bottom },
      ]}
    />
  )
}

export default memo(TransformNode)
